(function (Utils, $, undefined) {

  Utils.getSiteUrl = function(site) {
    if(site == 'uk')
      return 'https://services-uk.fossilgroup.com';
    if(site == 'fr')
      return 'https://services-fr.fossilgroup.com';
    if(site == 'de')
      return 'https://services-de.fossilgroup.com';
    if(site == 'ca')
      return 'https://services-ca.fossilgroup.com';
    
    return 'https://services-us.fossilgroup.com';
  }

  Utils.queryParam = function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  Utils.getCurrencySymbol = function() {
    if(App.country == 'fr' || App.country == 'de')
      return '€';

    if(App.country == 'uk')
      return '£';

    if(App.country == 'ca')
      return 'CAD';  

    return '$';
  }

  Utils.formatPrice = function(value) {
    if(isNaN(Number.parseFloat(value)))
      return value;

    var val = (Math.round(value * 100) / 100).toFixed(2);
    var formatted = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if(App.country == 'fr' || App.country == 'de')
      return formatted + '€';

    if(App.country == 'uk')
      return '£' + formatted;  

    if(App.country == 'ca')
      return '$' + formatted + ' CAD';  

    return '$' + formatted;
  }

}(window.Utils = window.Utils || {}, jQuery));


Array.prototype.unique = function() {
  return this.filter(function (value, index, self) { 
    return self.indexOf(value) === index;
  });
}